import { createContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AccountLayout from "./views/AccountLayout";
import AdminsView from "./views/AdminsView";
import Auth from "./classes/Auth";
import DashboardView from "./views/DashboardView";
import ForgotPasswordView from "./views/ForgotPasswordView";
import HelpView from "./views/HelpView";
import LandingView from "./views/LandingView";
import LoginView from "./views/LoginView";
import NotFoundView from "./views/NotFoundView";
import PublicLayout from "./views/PublicLayout";
import ResetPasswordView from "./views/ResetPasswordView";
import SettingsView from "./views/SettingsView";
import ShowUsersView from "./views/ShowUsersView";
import SignupView from "./views/SignupView";

const SessionContext = createContext();

function App() {
	const [loggedIn, setLoggedIn] = useState(Auth.isLoggedIn);
	const session = Auth.getSession();
	const role = (session && session.role) ? session.role : "";

	return (
		<SessionContext.Provider value={setLoggedIn}>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={(loggedIn) ? <AccountLayout /> : <PublicLayout />}>
						<Route index element={(loggedIn) ? <DashboardView redirect={true} /> : <LandingView />} />
						<Route path="login" element={(loggedIn) ? <DashboardView redirect={true} /> : <LoginView />} />
						<Route path="signup" element={(loggedIn) ? <DashboardView redirect={true} /> : <SignupView />} />
						<Route path="forgot-password" element={(loggedIn) ? <DashboardView redirect={true} /> : <ForgotPasswordView />} />
						<Route path="reset-password" element={(loggedIn) ? <DashboardView redirect={true} /> : <LandingView redirect={true} />} />
						<Route path="reset-password/:token" element={(loggedIn) ? <DashboardView redirect={true} /> : <ResetPasswordView />} />
						<Route path="help" element={(loggedIn) ? <DashboardView redirect={true} /> : <HelpView />} />
						<Route path="dashboard" element={(loggedIn) ? <DashboardView /> : <LandingView redirect={true} />} />
						<Route path="admins" element={(loggedIn) ? ((role === "superadmin") ? <AdminsView /> : <DashboardView redirect={true} />) : <LandingView redirect={true} />} />
						<Route path="settings" element={(loggedIn) ? <SettingsView /> : <LandingView redirect={true} />} />
						<Route path="lms" element={(loggedIn) ? <DashboardView redirect={true} /> : <LandingView redirect={true} />} />
						<Route path="lms/:lmsID" element={(loggedIn) ? <ShowUsersView /> : <LandingView redirect={true} />} />
						<Route path="*" element={(loggedIn) ? <DashboardView redirect={true} /> : <NotFoundView />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</SessionContext.Provider>
	);
};

export default App;
export { SessionContext };
